import PropTypes from 'prop-types';
import React from 'react';

export default function NoEscape(props) {
	const { children, className } = props;

	return (
		<div className={className} dangerouslySetInnerHTML={{ __html: children }} />
	);
}

NoEscape.propTypes = {
	children: PropTypes.any.isRequired,
	className: PropTypes.string,
};
